import COLOR_THEMES from "./colorThemes";
import $ from "jquery";
import {SIDEBAR_NAVIGATION_BUTTONS} from "../../../constants";

const sqftConfig = function() {
  let self = this;
  this.getMM = function() {
    function getDPI() {
      let div = document.createElement('div');
      div.style.height = '1in';
      let body = document.getElementsByTagName('body')[0];
      body.appendChild(div);
      let dpi = div.offsetHeight;
      body.removeChild(div);
      return dpi;
    }
    return getDPI() / 25.4;
  };
  this.isKiosk = (function() {
    let isKiosk = false;
    try {
      isKiosk = (parent && parent.parent && parent.parent.window.app && parent.parent.window.app.db);
    } catch(e) {
      isKiosk = false;
    }
    return isKiosk;
  })();
  this.kioskApp = (function() {
    if(self.isKiosk) {
      return parent.parent.window.app;
    }
  })();
  this.ctx = null;
  this.fieldWidth = self.getMM() * 13;
  this.fieldWidthCabinet = 4;
  this.shapeSize = 150;
  this.measureUnit = "Imperial";
  this.mmDivider = 1000;
  this.mm2ToM2Divider = 1000000;
  this.millimetersMultiplier = 25.4;
  this.inchesToMMultiplier = 1 / 39.37;
  this.sqftToMmMultiplier = 92903;
  this.sqftToM2Multiplier = 1 / 10.764;
  this.lnftToMmMultiplier = 304.8;
  this.waterfallImperialHeight = 36;
  this.waterfallMetricHeight = 900;
  this.miteredEdgeAdditionalImperialArea = 1.5;
  this.miteredEdgeAdditionalMetricArea = 38.1;
  this.edgeHeightImperial = 1.25;
  this.edgeHeightMetric = 20;
  this.workspace = {
    canvas: $('#workspace'),
    gridSize: 12,
    getScaledGridSize: function() {
      let scaledGridSize = Math.round(self.workspace.gridSize / self.scale);
      let nearest = (12 % scaledGridSize);
      return nearest < scaledGridSize / 2 ?
        scaledGridSize - nearest :
        scaledGridSize + nearest;
    },
    getDefaultScaledGridSize: function() {
      let scaledGridSize = Math.round(self.workspace.gridSize / self.defaultScale);
      let nearest = (12 % scaledGridSize);
      return nearest < scaledGridSize / 2 ?
        scaledGridSize - nearest :
        scaledGridSize + nearest;
    },
    fontSize: $(window).width() <= 1024 ? 14 : 16,
    fontSizeMetric: $(window).width() <= 1024 ? 14 : 16,
    fontSizeSmallest: $(window).width() <= 1024 ? 11 : 11,
    debug: false,
    snapToGrid: false,//todo
    menuItemActive: null
  };
  this.updateWorkspace = (windowWidth) => {
    this.workspace.fontSize = windowWidth <= 1024 ? 14 : 16;
    this.workspace.fontSizeMetric = windowWidth <= 1024 ? 14 : 16;
    this.workspace.fontSizeSmallest = windowWidth <= 1024 ? 11 : 11;
  };
  this.defaultScale = window.innerWidth <= 1024 ? 1.5 : 3.75;
  this.updateDefaultScale = (windowWidth) => {
    this.defaultScale = windowWidth <= 1024 ? 1.5 : 3.75;
  };
  this.defaultScaleExport = 7;
  this.scale = this.defaultScale;
  this.zoomSpeed = 5;
  this.controls = {
    scale: $('#scale-control'),
    scaleHoriz: $('#scale-control-horiz'),
    snapToGrid: $('#snapToGrid'),
    debug: $('#debug'),
    delete: $('#delete'),
    flipH: $('#flipH'),
    flipV: $('#flipV'),
    rotateLeft: $('#rotateLeft'),
    rotateRight: $('#rotateRight')
  };
  this.activeClass = 'active';
  this.activePalletItemClass = "pallet-tool-icon-selected";
  this.groups = {
    tools: "tools"
  };
  this.filterGroups = [];
  this.tutorialIsRunning = false;
  this.highlight = {
    points: false,
    lines: false,
    type: '',
    id: null,
    demoShow: false,
    rotateAngle: false,
  };
  this.activeTheme = Object.keys(COLOR_THEMES)[0]; // string
  this.SNAP_OFFSET = 12; // int
  this.activeFontRegular = "playregular"; // string
  this.activeFontBold = "playbold"; // string
  this.crownMoldingParams = {
    distance: 10
  }
  this.allowedNavItemsForMoovingPoint = [
    SIDEBAR_NAVIGATION_BUTTONS.freeDraw,
    SIDEBAR_NAVIGATION_BUTTONS.resize
  ];
  this.isDevMode = () => {
    return window.location.href.includes("dev=1")
  };
  this.isCabinetGroupInURL = () => {
    return window.location.href.includes("cabinets=1")
  };
  this.isSQFTEnabledInURL = () => {
    return window.location.hash.includes("sqft");
  };
  this.getMeasureMultiplier = function() {
    let measureMultiplier;
    switch (this.measureUnit) {
      case "Metric":
        measureMultiplier = this.millimetersMultiplier;
        break;
      case "Metric-meters":
        measureMultiplier = 1 / 39.37;
        break;
      case "Imperial":
      default:
        measureMultiplier = 1;
        break;
    }
    return measureMultiplier;
  };
  this.getMeasureUnitPosfix = function() {
    let measureUnitPosfix;
    switch (this.measureUnit) {
      case "Metric":
        measureUnitPosfix = "mm";
        break;
      case "Imperial":
      default:
        measureUnitPosfix = "\"";
        break;
    }
    return measureUnitPosfix;
  };
};

export default new sqftConfig()
